import Dompurify from 'dompurify';

import React, { memo } from 'react';

const purify = Dompurify(window);

purify.addHook('afterSanitizeAttributes', (node) => {
	if (node.tagName === 'A') {
	  node.setAttribute('target', '_blank');
	  node.setAttribute('rel', 'noopener');
	}
});

export interface SanitizedHtmlProps<As extends React.ElementType = React.ElementType> {
	as?: As;
	className?: string;
	html: string;
	onClick?: (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void
}

export const SanitizedHtml: React.FC<SanitizedHtmlProps> = memo(({ as: Component = 'div', html, ...rest }) => {
	const santized = purify.sanitize(html, { ADD_ATTR: [ 'target' ] });

	return (
		<Component
			{ ...rest }
			// eslint-disable-next-line react/no-danger
			dangerouslySetInnerHTML={ {
				__html: santized
			} } />
	);
});
